var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-form",
        {
          attrs: {
            model: _vm.model,
            "label-position": "top",
            "label-width": "12em"
          }
        },
        [
          _c("vue-form-generator", {
            ref: "form",
            attrs: {
              schema: _vm.schema,
              model: _vm.model,
              options: _vm.formOptions
            },
            on: { "model-updated": _vm.onModelUpdated }
          })
        ],
        1
      ),
      _c(
        "validation-observer",
        { ref: "observer", attrs: { tag: "div" } },
        [
          _c(
            "el-row",
            { staticClass: "margin ml-15" },
            [
              _c(
                "el-row",
                { staticClass: "margin mb-20", attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: {
                      label:
                        "O interessado possui outros processos de titulação de terra no Estado da Bahia?",
                      required: true
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      on: {
                        change: function($event) {
                          return _vm.changePossuiTitulacao(
                            $event,
                            "titulacaoInteressado"
                          )
                        }
                      },
                      model: {
                        value: _vm.model.titulacaoInteressado.possui,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.model.titulacaoInteressado,
                            "possui",
                            $$v
                          )
                        },
                        expression: "model.titulacaoInteressado.possui"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.model.titulacaoInteressado.possui
                ? _c(
                    "el-row",
                    { staticClass: "margin" },
                    [
                      _c(
                        "el-row",
                        { staticClass: "margin", attrs: { gutter: 30 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name:
                                    "N° do processo da titulação do interessado"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Processo",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoInteressado
                                                  .processo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model
                                                    .titulacaoInteressado,
                                                  "processo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoInteressado.processo"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2244463060
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name:
                                    "Municipio/Comunidade da titulação do interessado"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Município/Comunidade:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoInteressado
                                                  .municipio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model
                                                    .titulacaoInteressado,
                                                  "municipio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoInteressado.municipio"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1293943922
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name:
                                    "Denominação/Área da titulação do interessado"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Denominação/Área:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoInteressado
                                                  .area,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model
                                                    .titulacaoInteressado,
                                                  "area",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoInteressado.area"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  198301217
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "margin", attrs: { gutter: 30 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "Sit/Modal da titulação do interessado"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Sit/Modal:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoInteressado
                                                  .modal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model
                                                    .titulacaoInteressado,
                                                  "modal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoInteressado.modal"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2969970415
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { staticClass: "margin mb-20", attrs: { span: 24 } },
                [
                  _c("app-label", {
                    attrs: {
                      label:
                        "O cônjuge e/ou irmão(s) possui outros processos de titulação de terra no Estado da Bahia?",
                      required: true
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      on: {
                        change: function($event) {
                          return _vm.changePossuiTitulacao(
                            $event,
                            "titulacaoConjuge"
                          )
                        }
                      },
                      model: {
                        value: _vm.model.titulacaoConjuge.possui,
                        callback: function($$v) {
                          _vm.$set(_vm.model.titulacaoConjuge, "possui", $$v)
                        },
                        expression: "model.titulacaoConjuge.possui"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.model.titulacaoConjuge.possui
                ? _c(
                    "el-row",
                    { staticClass: "margin" },
                    [
                      _c(
                        "el-row",
                        { staticClass: "margin", attrs: { gutter: 30 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "N° do processo da titulação do cônjuge"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Processo",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoConjuge
                                                  .processo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.titulacaoConjuge,
                                                  "processo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoConjuge.processo"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  509243872
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name:
                                    "Municipio/Comunidade da titulação do cônjuge"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Município/Comunidade:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoConjuge
                                                  .municipio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.titulacaoConjuge,
                                                  "municipio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoConjuge.municipio"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  195593414
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name:
                                    "Denominação/Área da titulação do cônjuge"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Denominação/Área:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoConjuge.area,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.titulacaoConjuge,
                                                  "area",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoConjuge.area"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1856431701
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { staticClass: "margin", attrs: { gutter: 30 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: "Sit/Modal da titulação do cônjuge"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Sit/Modal:",
                                              required: true
                                            }
                                          }),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: { type: "text" },
                                            model: {
                                              value:
                                                _vm.model.titulacaoConjuge
                                                  .modal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.titulacaoConjuge,
                                                  "modal",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.titulacaoConjuge.modal"
                                            }
                                          }),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3141400091
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09d44ea1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d44ea1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppFormularioCertidaoArea.vue
// module id = null
// module chunks = 